// MerchantMarvelsFAQ.jsx
import React, { useMemo, useState } from "react";
import "./css/MerchantMarvelsFAQ.css";

export default function MerchantMarvelsFAQ() {
  const faqs = useMemo(
    () => [
      {
        q: "What is the Merchant Marvels 0% Processing Program?",
        a: (
          <>
            A unique program developed to help merchants nationwide save virtually
            100% on processing fees by offering their customers a discount for
            paying with Cash or in store gift cards.
          </>
        ),
      },
      {
        q: "What kind of businesses can use Merchant Marvels?",
        a: (
          <>
            Just about any business that accepts credit cards can benefit. From
            auto repair shops and daycare centers to retail establishments and
            professionals like doctors, lawyers, dentists and accountants, this
            program can put more money in your pocket every month — a lot of it!
          </>
        ),
      },
      {
        q: "What do I need to get started with Merchant Marvels?",
        a: (
          <>
            This is the fun part. We’ll send you everything you need in one handy
            package. You’ll receive a payment terminal, along with signage for
            your front door and terminal area explaining the discount for
            cash-paying customers. You’ll also receive free training, as will your
            sales staff.
          </>
        ),
      },
      {
        q: "OK, I really like the idea of Merchant Marvels . What do I do now?",
        a: (
          <>
            It&apos;s easy! Just press the <strong>GET STARTED</strong> button and
            fill out a simple form. It only takes a couple of minutes! Business
            and Personal information is confidential and secure. Welcome to the
            Merchant Marvels family of smart merchants who are saving money every day!
            <div className="mm-faq__cta">
              <button
                type="button"
                className="mm-faq__btn"
                onClick={() => {
                  // Replace with your routing/link logic:
                  // navigate("/get-started");
                  window.location.href = "#products"; // Example: scroll to products section
                }}
              >
                GET STARTED
              </button>
            </div>
          </>
        ),
      },
      {
        q: "What if I don't like the Dual Pricing Program?",
        a: (
          <>
           We have a 100% satisfaction guarantee. If for any reason you want to stop using Dual Pricing Program, we will immediately change you back to traditional interchange pricing. We got you covered!
          </>
        ),
      },
      {
        q: "Is this program proven? How common is dual pricing?",
        a: (
          <>
            Mercahant Marvels is new, yet thousands of merchants are already using Mercahant Marvels, and
            more are signing on every day. Gas stations have been using this
            program in the US for over 15 years. In addition, many national, state
            and local governments like the DMV, IRS, Post Offices, Schools and
            Courts use the dual pricing program and new federal regulations now
            allow merchants to reclaim their fair share of processing fees. Read
            More
          </>
        ),
      },
      {
        q: "Is it complicated to order, set up, or manage?",
        a: (
          <>
            Not at all. We’ve made it incredibly easy to order, set up and manage.
            If you have any questions, just give us a call and one of our
            super-smart (and very friendly) tech people will help you with any
            questions or concerns.
          </>
        ),
      },
      
    ],
    []
  );

  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex((current) => (current === idx ? -1 : idx));
  };

  return (
    <section className="mm-faq" aria-label="Merchant Marvels FAQs">
      <div className="mm-faq__container">
        <header className="mm-faq__header">
          <h2 className="mm-faq__title">Frequently asked questions</h2>
          <p className="mm-faq__subtitle">
            Got questions? We’re ready to help you find the answer.
          </p>
        </header>

        <div className="mm-faq__list">
          {faqs.map((item, idx) => {
            const isOpen = idx === openIndex;
            const contentId = `mm-faq-content-${idx}`;
            const buttonId = `mm-faq-button-${idx}`;

            return (
              <article className="mm-faq__item" key={idx}>
                <button
                  id={buttonId}
                  className="mm-faq__question"
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={contentId}
                  onClick={() => toggle(idx)}
                >
                  <span className="mm-faq__questionText">{item.q}</span>
                  <span className="mm-faq__icon" aria-hidden="true">
                    {isOpen ? "–" : "+"}
                  </span>
                </button>

                <div
                  id={contentId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`mm-faq__answerWrap ${isOpen ? "is-open" : ""}`}
                >
                  <div className="mm-faq__answer">{item.a}</div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}